import React, { useState } from 'react';
import styles from '../styles/interactive-docs.module.css';

export const PassportWireframe = () => {
    const [activeTab, setActiveTab] = useState('main');

    const tabs = [
        { id: 'main', num: '❷', label: 'Основное' },
        { id: 'ownership', num: '❸', label: 'Владение' },
        { id: 'status', num: '❹', label: 'Статусы' },
        { id: 'media', num: '❺', label: 'Медиа' },
        { id: 'extra', num: '❻', label: 'Доп. инфо' }
    ];

    return (
        <div className={styles.passportWfContainer}>
            <div className={styles.passportWfStage}>
                {/* 1. Плавающая панель быстрых действий (слева) */}
                <div className={styles.passportWfActionCol}>
                    <div className={styles.passportWfActionPill}>
                        <button className={styles.passportWfActionBtn} title="Перерисовать геометрию">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                        </button>
                        <button className={styles.passportWfActionBtn} title="Подключаемые модули">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M23 4v6h-6" />
                                <path d="M1 20v-6h6" />
                                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                            </svg>
                        </button>
                        <button className={`${styles.passportWfActionBtn} ${styles.passportWfActionDelete}`} title="Удалить объект">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                            </svg>
                        </button>
                        <div className={styles.passportWfTagBadge}>
                            <span className={styles.wfNumTag}>❶</span>
                        </div>
                    </div>
                </div>

                {/* 2. Основная карточка "Настройка объекта" */}
                <div className={styles.passportWfCard}>
                    {/* Шапка карточки */}
                    <div className={styles.passportWfHeader}>
                        <h3 className={styles.passportWfTitle}>Настройка объекта</h3>
                        <span className={styles.passportWfHint}>Кликайте по вкладкам ❷—❻</span>
                    </div>

                    {/* Навигатор по 5 вкладкам */}
                    <div className={styles.passportWfTabsWrapper}>
                        <div className={styles.passportWfTabsHeader}>
                            <div className={styles.passportWfTabsList}>
                                {tabs.map(t => (
                                    <button
                                        key={t.id}
                                        className={`${styles.passportWfTabBtn} ${activeTab === t.id ? styles.passportWfTabActive : ''}`}
                                        onClick={() => setActiveTab(t.id)}
                                    >
                                        <span style={{ opacity: 0.85, marginRight: '3px' }}>{t.num}</span>
                                        <span>{t.label}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Тело формы с полями */}
                    <div className={styles.passportWfBody}>
                        {activeTab === 'main' && (
                            <div className={styles.passportWfForm}>
                                <div className={styles.passportWfField}>
                                    <label>Название:</label>
                                    <div className={styles.passportWfInput}>66:59:0102001:185</div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Кадастровый номер:</label>
                                    <div className={styles.passportWfInput}>66:59:0102001:185</div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Категория:</label>
                                    <div className={styles.passportWfSelect}>
                                        <span>Готовится к продаже</span>
                                        <span>▾</span>
                                    </div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Площадь (м²):</label>
                                    <div className={styles.passportWfInput}>25 925</div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'ownership' && (
                            <div className={styles.passportWfForm}>
                                <div className={styles.passportWfPrivateNotice}>
                                    🔒 <strong>Служебные данные:</strong> скрыты от гостей на публичной карте
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Собственник / Владелец:</label>
                                    <div className={styles.passportWfInput}>ООО «Инвест-Девелопмент»</div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Арендаторы:</label>
                                    <div className={styles.passportWfArrayItem}>
                                        <span>ИП Смирнов А.В.</span>
                                        <span className={styles.passportWfSubtext}>320 м²</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'status' && (
                            <div className={styles.passportWfForm}>
                                <div className={styles.passportWfStatusRow}>
                                    <span className={`${styles.passportWfStatusBadge} ${styles.passportWfStatusSale}`}>
                                        ☑️ В продаже
                                    </span>
                                    <span className={`${styles.passportWfStatusBadge} ${styles.passportWfStatusOff}`}>
                                        ☐ В строительстве
                                    </span>
                                    <span className={`${styles.passportWfStatusBadge} ${styles.passportWfStatusOff}`}>
                                        ☐ Запланировано
                                    </span>
                                </div>
                                <div className={styles.passportWfHintText}>
                                    * Включение флажков окрашивает значки и добавляет фильтры в легенду.
                                </div>
                            </div>
                        )}

                        {activeTab === 'media' && (
                            <div className={styles.passportWfForm}>
                                <div className={styles.passportWfField}>
                                    <label>Фотографии:</label>
                                    <div className={styles.passportWfMediaItem}>
                                        <span>🖼️ Фото_участка_фасад.jpg</span>
                                        <span className={styles.passportWfSubtext}>Главный заезд</span>
                                    </div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Ссылки:</label>
                                    <div className={styles.passportWfMediaItem}>
                                        <span>🔗 Выписка ЕГРН (PDF)</span>
                                        <span className={styles.passportWfSubtext}>Открыть</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'extra' && (
                            <div className={styles.passportWfForm}>
                                <div className={styles.passportWfField}>
                                    <label>Дополнительная информация:</label>
                                    <div className={styles.passportWfTextarea}>
                                        Участок правильной формы, примыкает к лесной зоне. Подведены коммуникации.
                                    </div>
                                </div>
                                <div className={styles.passportWfField}>
                                    <label>Характеристики («Параметр — Значение»):</label>
                                    <div className={styles.passportWfCustomField}>
                                        <span className={styles.passportWfKey}>Электричество</span>
                                        <span className={styles.passportWfVal}>15 кВт</span>
                                    </div>
                                    <div className={styles.passportWfCustomField}>
                                        <span className={styles.passportWfKey}>Газ</span>
                                        <span className={styles.passportWfVal}>по границе</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Подвал с кнопками */}
                    <div className={styles.passportWfFooter}>
                        <div className={styles.passportWfBtnRow}>
                            <button className={styles.passportWfCancelBtn}>Отмена</button>
                            <button className={styles.passportWfSaveBtn}>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
